export enum LoadState {
  UNDEFINED,
  LOADING,
  LOADED,
  FAILED,
}
